
import { EventEmitter } from '@angular/core';

export class Settings {
    constructor(public name: string,
        public title: string,
        public emitters: {
            needReloadMenu: EventEmitter<boolean>,
            needReloadDashboard: EventEmitter<boolean>,
            needReloadLoader: EventEmitter<boolean>,
            steps: EventEmitter<boolean>
        },
        public configs: {
            saveFilterInSession: boolean,
            defaultQuantityByPage: number
        },
        public theme: {
            menu: string,
            menuType: string,
            showMenu: boolean,
            navbarIsFixed: boolean,
            footerIsFixed: boolean,
            sidebarIsFixed: boolean,
            showSideChat: boolean,
            sideChatIsHoverable: boolean,
            skin: string
        },
        public FCMTokens: string[],
        public FCMTopics: string[]) { }
}
